<p-toast key="headless" position="top-center" [dt]="toastDesignTokens">
  <ng-template let-message pTemplate="headless" #headless let-closeFn="closeFn">
    @let classes = styles(message.severity);

    <div [class]="classes.wrapper()">
      <div [class]="classes.content()">
        <div class="flex gap-4">
          <div class="flex items-center">
            @switch (message.severity) {
              @case ('info') {
                <edu-icon [icon]="Icons.INFO" [iconClasses]="classes.icon()" />
              }
              @case ('success') {
                <edu-icon [icon]="Icons.CHECK_CIRCLE" [iconClasses]="classes.icon()" />
              }
              @case ('warn') {
                <edu-icon [icon]="Icons.WARNING" [iconClasses]="classes.icon()" />
              }
              @case ('error') {
                <edu-icon [icon]="Icons.X_CIRCLE" [iconClasses]="classes.icon()" />
              }
            }
          </div>
          <div class="flex flex-1 flex-col items-start justify-center">
            <span [class]="classes.title()">{{
              message.summary | transloco: message.data.translationParams
            }}</span>
            <div [class]="classes.description()">
              {{ message.detail | transloco: message.data.translationParams }}
            </div>
          </div>
          <div class="flex items-center">
            <edu-icon-button
              [ariaLabel]="'globals.toast.closeAriaLabel' | transloco"
              [icon]="Icons.X_MARK"
              (click)="closeFn($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
